import { useEffect, useMemo, useRef, useState } from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap'
import Card from 'react-bootstrap/Card'
import Image from 'react-bootstrap/Image'

import {
  FaEnvelope,
  FaPhone,
  FaIdBadge,
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaArrowLeft,
  FaHashtag,
} from 'react-icons/fa'
import {
  LuGraduationCap,
} from 'react-icons/lu'
import {
  BsEyeFill,
  BsArrowLeft,
} from 'react-icons/bs'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import ApiEndpoints, { BASE_URL, BASE_URL_Upload } from './commonComponents/ApiEndpoints'
import axios from 'axios'
import Cookies from 'js-cookie'
import {
  NO_STAMP_SRC,
  getInstituteStampPathFromRecord,
  resolveInstituteLogoSrc,
  resolveInstituteStampSrc,
} from '../utils/instituteBranding'
import html2pdf from 'html2pdf.js'
import html2canvas from 'html2canvas'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'

function blobToDataURL(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}

async function fetchImageAsDataUrlForCanvas(url) {
  if (!url || url.startsWith('data:')) return url
  try {
    const res = await fetch(url, { mode: 'cors', credentials: 'omit' })
    if (res.ok) return await blobToDataURL(await res.blob())
  } catch {
    /* cross-origin without CORS */
  }
  try {
    const proxied = `https://images.weserv.nl/?url=${encodeURIComponent(url)}`
    const res = await fetch(proxied)
    if (!res.ok) throw new Error(String(res.status))
    return await blobToDataURL(await res.blob())
  } catch {
    /* try second proxy */
  }
  try {
    const res = await fetch(
      `https://api.allorigins.win/raw?url=${encodeURIComponent(url)}`,
    )
    if (!res.ok) throw new Error(String(res.status))
    return await blobToDataURL(await res.blob())
  } catch (e) {
    console.warn('Canvas export: could not inline image', url, e)
    return url
  }
}

async function inlineImagesForHtml2Canvas(rootEl) {
  const imgs = [...rootEl.querySelectorAll('img')]
  const backups = []
  for (const img of imgs) {
    const current = img.currentSrc || img.src
    if (!current || current.startsWith('data:')) continue
    backups.push([img, current])
    try {
      const dataUrl = await fetchImageAsDataUrlForCanvas(current)
      img.src = dataUrl
      if (img.decode) await img.decode().catch(() => {})
    } catch {
      backups.pop()
    }
  }
  return () => {
    for (const [img, src] of backups) {
      img.src = src
    }
  }
}

const normalizeUserForCard = (u) => {
  if (!u) return null
  return {
    ...u,
    student_image:
      u.profile_img_url ||
      u.student_image ||
      u.profile_image ||
      u.teacher_image ||
      u.user_image,
    admission_number: u.admission_number ?? u.id,
  }
}

function getUserRoleLabel(u) {
  if (!u || typeof u !== 'object') return 'N/A'
  if (u.designation != null && String(u.designation).trim() !== '') {
    return String(u.designation).trim()
  }
  if (u.user_type) {
    return u.user_type.charAt(0).toUpperCase() + u.user_type.slice(1)
  }
  return 'N/A'
}

export default function UserIdCard() {
  const { isCollapsed } = useSidebar()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        /**
         * Sidebar width:
         * - Expanded: 245px  (inline style)
         * - Collapsed: 85px (.sidebar-collapsed CSS with !important)
         * Add 1px gap between sidebar edge and dashboard content.
         */
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        // On mobile, sidebar becomes off-canvas, so no left offset is needed
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    // Set initial margin and mobile flag
    handleResize()

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  const { id } = useParams()
  const location = useLocation()
  console.log('ID OF USER: ', id)
  const navigate = useNavigate()
  // const idCardRef = useRef(null)
  const frontRef = useRef()
  const backRef = useRef()

  const downloadAsJPG = async (element, filename) => {
    const restoreImages = await inlineImagesForHtml2Canvas(element)
    try {
      const canvas = await html2canvas(element, {
        backgroundColor: '#fff',
        useCORS: true,
        allowTaint: false,
        imageTimeout: 15000,
      })
      const image = canvas.toDataURL('image/jpeg', 1.0)

      const link = document.createElement('a')
      link.href = image
      link.download = `${filename}.jpg`
      link.click()
    } finally {
      restoreImages()
    }
  }

  const [data, setData] = useState('')
  console.log('data is define here', data)
  const [img, setImg] = useState(null)
  const [courses, setCourses] = useState([])
  console.log('COURSES: ', courses)
  const [classes, setClasses] = useState([])
  const [institutes, setInstitutes] = useState('')
  const [institueLogoApi, setInstitueLogoApi] = useState('/no_image.png')
  const [stampUrlApi, setStampUrlApi] = useState(NO_STAMP_SRC)
  // const img = new Image()
  const [loading, setLoading] = useState(true)

  // useEffect(() => {
  //   const storedInstitute = Cookies.get('institute_name')
  //   if (storedInstitute) {
  //     setInstitutes(storedInstitute)
  //   }
  // }, [])

    const [instituteCookies, setInstituteCookies] = useState(null);
    
    
       
        useEffect(() => {
          const storedInstituteName = Cookies.get("name");
          const storedAddress = Cookies.get("address");
          const storedPincode = Cookies.get("pincode");
          const storedSessionName = Cookies.get("session_name");
          console.log("Stored institute from cookies:", storedInstituteName);
          if (storedInstituteName || storedAddress) {
            setInstituteCookies({
              name: storedInstituteName,
              address: storedAddress,
              pincode: storedPincode,
              session_name: storedSessionName,
            });
          }
        }, []);


  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
    ApiEndpoints.getAllClasses().then((res) => setClasses(res.data.data))
  }, [])

  useEffect(() => {
    if (!data?.institute_id) {
      console.log('No institute_id found in data')
      return
    }

    console.log('Fetching institutes for institute_id:', data.institute_id)

    ApiEndpoints.getAllInstitutes()
      .then((res) => {
        console.log('API Response:', res.data)

        if (Array.isArray(res.data.data)) {
          console.log('Institutes Array:', res.data.data)

          const studentInstitute = res.data.data.find(
            (inst) => inst.institute_id === data.institute_id, // Corrected
          )

          console.log('Matched studentInstitute:', studentInstitute)

          if (studentInstitute) {
            setInstitueLogoApi(
              resolveInstituteLogoSrc(
                Cookies.get('institute_logo') || studentInstitute.institute_logo,
              ),
            )
            setInstitutes(studentInstitute)
            setStampUrlApi(
              resolveInstituteStampSrc(
                Cookies.get('institute_stamp') ||
                  Cookies.get('stamp_url_img') ||
                  getInstituteStampPathFromRecord(studentInstitute),
              ),
            )
          } else {
            console.log('No matching institute found, setting default')
            setInstitutes({ institute_name: 'Unknown Institute' })
          }
        } else {
          console.log('Invalid data format received:', res.data)
        }
      })
      .catch((error) => console.error('Error fetching institutes:', error))
  }, [data?.institute_id])

  useEffect(() => {
    const fromState = location.state?.userData
    if (fromState) {
      const n = normalizeUserForCard(fromState)
      setData(n)
      setImg(n)
      setLoading(false)
      return
    }

    const fetchUserData = async () => {
      try {
        if (!id) {
          setLoading(false)
          return
        }

        const institueId = Cookies.get('institute_id')
        const userCookie = Cookies.get('user')
        let token = null
        if (userCookie) {
          try {
            token = JSON.parse(userCookie).token
          } catch (e) {
            /* ignore */
          }
        }
        if (!institueId || !token) {
          setLoading(false)
          return
        }

        const response = await axios.get(BASE_URL + '/get/users', {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'institute-Id': Number(institueId),
          },
        })
        const list = Array.isArray(response.data) ? response.data : []
        const matched = list.find((u) => String(u.id) === String(id))
        if (matched) {
          const n = normalizeUserForCard(matched)
          setData(n)
          setImg(n)
        }
      } catch (error) {
        console.error('Error while fetching user data:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchUserData()
  }, [id, location.state])

  const cardStatusLabel = useMemo(() => {
    const fromNav = location.state?.statusLabel
    if (fromNav != null && String(fromNav).trim() !== '') {
      return String(fromNav).trim()
    }
    return getUserRoleLabel(data)
  }, [location.state?.statusLabel, data])

  // Same resolution as UserProfile.js / TeacherIdCard.js (default photo + API fields + relative upload paths)
  const defaultUserPhoto = `${process.env.PUBLIC_URL || ''}/student.png`
  const userImageSrc = useMemo(() => {
    const raw = data && typeof data === 'object' ? data.student_image : null
    if (
      raw == null ||
      String(raw).trim() === '' ||
      String(raw).toLowerCase() === 'null' ||
      String(raw).toLowerCase() === 'undefined'
    ) {
      return defaultUserPhoto
    }
    const s = String(raw).trim()
    if (/^https?:\/\//i.test(s)) return s
    const base = BASE_URL_Upload.replace(/\/$/, '')
    return `${base}/${s.replace(/^\//, '')}`
  }, [data])


  const handlePrint = () => {
    const printWindow = window.open('', '', 'width=1000,height=700')

    const frontCardHTML = document.querySelector('.front-card')?.outerHTML || ''
    const backCardHTML = document.querySelector('.back-card')?.outerHTML || ''

    printWindow.document.write(`
      <html>
        <head>
          <title>ID Card</title>

          <style>
  @page {
    // size: A5 portrait;
    margin: 0;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    background: white;
  }

  .print-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    flex-direction: row;
    gap: 20px;
    padding: 10mm;
    box-sizing: border-box;
  }

  .page-break {
    page-break-after: always;
  }

  .card {
    width: 360px;
    height: 500px;
    // width: 86mm ;
    // height: 55mm ;
    border: .5px solid #000;
    border-radius: 15px;
    padding: 5px;
    box-sizing: border-box;
    overflow: hidden;
    background-color: #fff;
  }

  .front-card, .back-card {
    box-shadow: none !important;
  }

  .institute-header {
    height: 67px !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    text-align: center !important;
    flex-direction: column !important;
  }
.inst-name{
    font-size:18px !important;
    margin-top:2px !important;
}
    .inst-about{
    font-size:15px !important;
  color: rgba(255, 255, 255, 0.6);
}
  .student-name {
    text-align: center !important;
    margin-top: .7rem !important;

  }
.student-bio {
  margin-left: 10px !important;
  color: #223843;
}

.student-bio .bio-item {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 8px;
  gap:2px;
  color: #223843;
}

.student-bio .bio-item svg {
  margin-bottom: 4px; /* Space between icon and text */
  color: #223843;
  font-size: 18px;
}

.student-bio .bio-item p {
  margin: 0;
  font-size: 13px;
  color: #223843;
}

  .stamp {
    display: flex !important;
    justify-content: center !important;
    margin-top: 1.8rem !important;
    // margin-bottom: -6px !important;
  }


.print-image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem !important;
}

.print-image {
  width: 50px !important;
  height: 50px !important;
  border: 2px solid #223843 !important;
  background: white !important;
  object-fit: cover !important;
}

  h1, h2, h3, h4, h5, h6, p, span, strong {
    font-size: 15px !important;
    margin: 2px 0 !important;
  }

  .text-primary {
    color: #223843 !important;
  }

  .small {
    font-size: 13px !important;
  }

  .fw-bold {
    font-weight: bold;
  }

  .rounded-circle {
    border-radius: 50% !important;
  }

  // Back portion of ID Card
.inst-top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // gap: 5px;
  // padding: 0 5px;
}

.inst-logo img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2rem !important;
  margin-bottom: 1rem !important;
  max-width:80% !important;
}

.inst-info {
  text-align: center;
  flex: 1;
  letter-spacing:2px !important;
    font-size: 19px;
  margin-top: 0rem;
}

.ins-card{
  margin-top: 2rem;
}
.inst-data {
  flex: 2;
  text-align: start;
  padding: 0 5px;
  color: #6c757d !important;
  margin-bottom: 2rem;

}
.inst-data p {
  font-size: 16px !important;
}

.inst-location {
  margin-left: 20px !important;
  font-size: 15px;
}

</style>

        </head>
        <body>
          <div class="print-container page-break">
            ${frontCardHTML}
          </div>
          <div class="print-container">
            ${backCardHTML}
          </div>
          <script>
            window.onload = function() {
              window.print();
              setTimeout(() => { window.close(); }, 500);
            };
          </script>
        </body>
      </html>
    `)

    printWindow.document.close()
    printWindow.focus()
  }

  const handleDownloadBoth = () => {
    if (frontRef.current) downloadAsJPG(frontRef.current, 'ID_Card_Front')
    if (backRef.current) downloadAsJPG(backRef.current, 'ID_Card_Back')
  }
  // const handleDownloadPDF = () => {
  //   const element = document.getElementById('print-idcard')
  //   html2pdf()
  //     .from(element)
  //     .set({
  //       margin: 0,
  //       filename: `${data?.name || 'id_card'}.pdf`,
  //       html2canvas: { scale: 4 },
  //       jsPDF: { orientation: 'landscape', unit: 'mm', format: 'a5' },
  //     })
  //     .save()
  // }

  const handleBack = () => {
    navigate('/AddUser')
  }
  const handleUserProfile = () => {
    navigate('/user-profile', { state: { userData: data } })
  }
  return (
    <>
      <style>
        {`
         @media (max-width: 767.98px) {
          .responsive-btn {
            margin-top:5px !important;
            padding: 0.25rem 0.5rem !important;
            font-size: 0.875rem !important; /* equivalent to btn-sm */
          }
        }
        @media (max-width: 767.98px) {
          .responsive-btn {
            // padding: 0.25rem 0.5rem !important;
            // font-size: 0.87rem !important;
          }
          .card-id-container{
           margin-top: 4rem !important ;
           margin-left:auto !important;
           margin-right:auto !important;
           max-width:100% !important;
          }
          .inst-name,
          .inst-about {
            font-size: 0.8rem !important;
            text-align: center;
          }

          .student-name h6 {
            font-size: 1rem !important;
          }

          .back-card{
            display:block !important;
            margin-left:auto !important;
            margin-right:auto !important;
          }
        }

        `}
      </style>
      <div 
        style={{ 
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          marginRight: '0px',
          marginBottom: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px',
        }}
      >
        {data && !loading ? (
          <>
            {/* Header */}
            <div
              className="container-fluid p-0"
              style={{
                marginTop: window.innerWidth < 992 ? '55px' : '-12px',
                paddingLeft: '0px',
                paddingRight: '0px',
              }}
            >
              <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
                <div 
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    background: '#F3F4F6',
                    paddingLeft: '28px',
                    paddingRight: '28px',
                    paddingTop: '12px',
                    paddingBottom: '12px',
                    overflow: 'visible',
                    borderBottom: '1px solid #D1D3D4',
                    width: '100%',
                  }}
                >
                  
                  {/* Left: Title and Logo */}
                  <div className="d-flex align-items-center gap-3">
                    {/* School Logo */}
                    <div style={{ 
                      width: '40px', 
                      height: '40px', 
                      borderRadius: '50%', 
                      overflow: 'hidden', 
                      background: '#223843',
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center', 
                      flexShrink: 0,
                    }}>
                      {!logoError ? (
                        <img 
                          src={institueLogoApi} 
                          alt="School Logo" 
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          onError={() => setLogoError(true)}
                        />
                      ) : (
                        <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                      )}
                    </div>
                    
                    <h3 
                      className="m-0 fw-bold" 
                      style={{ 
                        letterSpacing: '-0.02em',
                        overflow: 'visible',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        fontSize: 'clamp(18px, 2.5vw, 22px)',
                        color: '#223843',
                        lineHeight: '1.2',
                        fontFamily: 'Inter, system-ui, sans-serif',
                      }}
                    >
                      <span style={{ color: '#223843' }}>{data.name}</span>'s ID Card
                    </h3>
                  </div>
                  
                  {!isMobile && <ProfileDropdown />}
                </div>

                {/* Buttons row (below header) */}
                <div
                  className="d-flex justify-content-center justify-content-md-end align-items-center gap-3 flex-nowrap"
                  style={{
                    // background: '#F3F4F6',
                    paddingLeft: '28px',
                    paddingRight: '28px',
                    paddingTop: '10px',
                    // paddingBottom: '10px',
                    // borderBottom: '1px solid #D1D3D4',
                    width: '100%',
                  }}
                >
                  {/* Go to Profile Button */}
                  <div
                    className="d-flex align-items-center gap-2"
                    style={{ transition: 'all 0.2s ease', cursor: 'pointer' }}
                    onMouseEnter={(e) => {
                      const button = e.currentTarget.querySelector('button')
                      const text = e.currentTarget.querySelector('span')
                      if (button) {
                        button.style.backgroundColor = '#223843'
                        button.style.borderColor = '#223843'
                        button.style.transform = 'scale(1.05)'
                      }
                      if (text) {
                        text.style.transform = 'scale(1.05)'
                      }
                      e.currentTarget.style.transform = 'scale(1.02)'
                    }}
                    onMouseLeave={(e) => {
                      const button = e.currentTarget.querySelector('button')
                      const text = e.currentTarget.querySelector('span')
                      if (button) {
                        button.style.backgroundColor = '#223843'
                        button.style.borderColor = '#223843'
                        button.style.transform = 'scale(1)'
                      }
                      if (text) {
                        text.style.transform = 'scale(1)'
                      }
                      e.currentTarget.style.transform = 'scale(1)'
                    }}
                  >
                    <button
                      onClick={handleUserProfile}
                      style={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '50%',
                        border: '1px solid #223843',
                        backgroundColor: '#223843',
                        color: '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        flexShrink: 0,
                      }}
                      title="Go to User Profile"
                    >
                      <BsEyeFill size={20} />
                    </button>
                    <span
                      style={{
                        fontSize: isMobile ? '13px' : '14px',
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                        fontWeight: '500',
                        transition: 'transform 0.2s ease',
                        display: 'inline-block',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      Go to{' '}
                      <span className="fw-bold text-primary">{data.name}</span>{' '}
                      Profile
                    </span>
                  </div>

                  {/* Go to Student List Button */}
                  <div
                    className="d-flex align-items-center gap-2"
                    style={{ transition: 'all 0.2s ease', cursor: 'pointer' }}
                    onMouseEnter={(e) => {
                      const button = e.currentTarget.querySelector('button')
                      const text = e.currentTarget.querySelector('span')
                      if (button) {
                        button.style.backgroundColor = '#223843'
                        button.style.borderColor = '#223843'
                        button.style.transform = 'scale(1.05)'
                      }
                      if (text) {
                        text.style.transform = 'scale(1.05)'
                      }
                      e.currentTarget.style.transform = 'scale(1.02)'
                    }}
                    onMouseLeave={(e) => {
                      const button = e.currentTarget.querySelector('button')
                      const text = e.currentTarget.querySelector('span')
                      if (button) {
                        button.style.backgroundColor = '#223843'
                        button.style.borderColor = '#223843'
                        button.style.transform = 'scale(1)'
                      }
                      if (text) {
                        text.style.transform = 'scale(1)'
                      }
                      e.currentTarget.style.transform = 'scale(1)'
                    }}
                  >
                    <button
                      onClick={handleBack}
                      style={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '50%',
                        border: '1px solid #223843',
                        backgroundColor: '#223843',
                        color: '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        flexShrink: 0,
                      }}
                      title="Go to Manage Users"
                    >
                      <BsArrowLeft size={20} />
                    </button>
                    <span
                      style={{
                        fontSize: isMobile ? '13px' : '14px',
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                        fontWeight: '500',
                        transition: 'transform 0.2s ease',
                        display: 'inline-block',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      Go to Manage Users
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="print-idcard"
              // style={{ marginTop: '-3rem' }}
              class="printable-section "
            >
              <Container
                className="d-flex justify-content-center align-items-center vh-75 card-id-container"
                style={{ minHeight: '65vh' }}
              >
                <Row className="justify-content-center">
                  {/* Front Side of ID Card */}
                  {/* <Col>
                    <Card
                      ref={frontRef}
                      className="p-3 shadow border border-2 text-center position-relative front-card"
                      style={{
                        width: '360px',
                        height: '500px',
                        borderRadius: '15px',
                        overflow: 'hidden',
                      }}
                    > */}
                  <Col
                    xs={12}
                    md={6}
                    className="d-flex justify-content-center align-items-center mb-4"
                  >
                    <Card
                      style={{
                        width: '100%',
                        maxWidth: '360px',
                        height: '500px',
                        marginTop: '20px',
                        borderRadius: '15px',
                        overflow: 'hidden',
                      }}
                      className="p-3 shadow border border-2 text-center position-relative front-card"
                      ref={frontRef}
                    >
                      <div
                        className="py-2 institute-header"
                        style={{
                          background: '#223843',
                          color: 'white',
                          borderTopLeftRadius: '12px',
                          borderTopRightRadius: '12px',
                          fontWeight: 'bold',
                          letterSpacing: '1px',
                          WebkitPrintColorAdjust: 'exact',
                          printColorAdjust: 'exact',
                          // height: '80px',
                        }}
                      >
                        <h6 className="m-0 inst-name">
                          {instituteCookies?.name || 'Institute Management'}{' '}
                        </h6>
                        <p className="m-0 text-white-50 small inst-about">
                          Education for Excellence
                        </p>
                      </div>

                      <Card.Body
                        className="p-2 position-relative"
                        style={{ zIndex: 2 }}
                      >
                        {/* Profile Image */}
                        <div className="print-image-wrapper d-flex justify-content-center my-2">
                          <Image
                            className="img-style"
                            src={userImageSrc}
                            style={{
                              width: '90px',
                              height: '90px',
                              border: '1px solid #223843',
                              background: 'white',
                            }}
                          />
                        </div>

                        {/* Student Details */}
                        <div
                          className="student-name fw-bold"
                          style={{
                            width: '100%',
                            maxWidth: '100%',
                            boxSizing: 'border-box',
                          }}
                        >
                          <h6 className="fw-bold">
                            {data?.name ? data.name.toUpperCase() : 'N/A'}
                          </h6>
                          <p className="text-muted small m-0">
                            Session : {instituteCookies?.session_name || 'N/A'}
                          </p>
                          <p
                            className="text-muted small m-0 mt-1"
                            title={cardStatusLabel}
                            style={{
                              fontSize: '11px',
                              fontWeight: 600,
                              lineHeight: 1.25,
                              maxWidth: '100%',
                              paddingLeft: '4px',
                              paddingRight: '4px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {cardStatusLabel}
                          </p>
                        </div>
                        <hr className="mt-2 mb-2" />

                        <Row className="text-start ps-3 student-bio fw-bold">
                          <Col
                            xs={12}
                            style={{color:"#223843"}}
                            className="d-flex align-items-center fs-6 mt-2 bio-item"
                          >
                            <FaIdBadge className="me-2" />{' '}
                            <p className="m-0 small">
                              <strong>ID:</strong>{' '}
                              {data?.admission_number || ''}
                            </p>
                          </Col>

                          <Col
                            xs={12}
                            style={{color:"#223843"}}
                            className="d-flex align-items-center fs-6 mt-2 bio-item"
                          >
                            <FaCalendarAlt className="me-2" />{' '}
                            <p className="m-0 small">
                              <strong>Join:</strong>{' '}
                              {data?.created_at
                                ? new Date(data.created_at).toLocaleDateString(
                                    'en-GB',
                                    {
                                      day: '2-digit',
                                      month: 'short',
                                      year: 'numeric',
                                    },
                                  )
                                : null}
                            </p>
                          </Col>

                          <Col
                            xs={12}
                            style={{color:"#223843"}}
                            className="d-flex align-items-center fs-6 mt-2 bio-item"
                          >
                            <FaEnvelope className="me-2" />{' '}
                            <p className="m-0 small">
                              <strong>Email:</strong> {data?.email || ''}
                            </p>
                          </Col>

                          <Col
                            xs={12}
                            style={{color:"#223843"}}
                            className="d-flex align-items-center fs-6 mt-2 bio-item"
                          >
                            <FaPhone className="me-2" />{' '}
                            <p className="m-0 small">
                              <strong>Phone:</strong> +91 {data?.phone_number || 'N/A'}
                            </p>
                          </Col>
                        </Row>

                        <hr className="mt-2 mb-4 mt-2" />
                        {/* Director Signature */}
                        <div className="text-center mt-2 stamp">
                          {/* <FaSignature size={25} className="text-muted" /> */}
                          <Image
                            src={stampUrlApi}
                            alt="stamp"
                            style={{
                              width: '90px',
                              height: '90px',
                              marginTop: '-1.15rem',
                            }}
                            roundedCircle
                            onError={(e) => {
                              e.currentTarget.onerror = null
                              e.currentTarget.src = NO_STAMP_SRC
                            }}
                          />
                          {/* <p className="fw-bold m-0 small">
                          Director's Signature
                        </p> */}
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  {/* Back Side of ID Card */}
                  <Col>
                    <Card
                      ref={backRef}
                      className="p-3 shadow border border-2 text-center position-relative back-card"
                      style={{
                        // width: '86mm',
                        // height: '55mm',
                        // borderRadius: '15px',
                        // overflow: 'hidden',
                        width: '360px',
                        height: '500px',
                        marginTop: '20px',
                        borderRadius: '15px',
                        // background: '#ffffff',
                        overflow: 'hidden',
                      }}
                    >
                      {/* logo*/}
                      <div className="inst-top-row">
                        <div className="mt-5 mb-2 inst-logo">
                          <Image
                            className="img-style"
                            src={
                              typeof institueLogoApi === 'string'
                                ? institueLogoApi.replace(/^http:\/\//i, 'https://')
                                : institueLogoApi
                            }
                            alt="Logo"
                            style={{
                              width: '150px',
                              height: '150px',
                              borderRadius: '50%',
                              objectFit: 'cover',
                            }}
                            onError={(e) => {
                              e.currentTarget.onerror = null
                              e.currentTarget.src = '/no_image.png'
                            }}
                          />
                        </div>
                        <div className="py-2 inst-info">
                          <h5 className="m-0">INSTITUTE INFORMATION</h5>
                        </div>
                      </div>

                      <Card.Body className="p-3 mt-3 ins-card">
                        <div className="inst-data">
                          <p className="small text-muted text-start fw-semibold ">
                            {instituteCookies?.name || 'This Institute'} is a premier
                            educational institution dedicated to excellence in
                            technical education.
                          </p>
                        </div>

                        <Row className="text-start ps-3 mt-3 inst-location student-bio">
                          <Col
                            xs={12}
                            style={{color:"#223843"}}
                            className="d-flex align-items-center fs-6 bio-item"
                          >
                            <FaMapMarkerAlt className="me-2" />{' '}
                            <p className="m-0 small">
                              {' '}
                              <span className="fw-bold">Address : </span>{' '}
                              {instituteCookies?.address || ''}{' '}
                            </p>
                          </Col>

                          <Col
                            xs={12}
                            style={{color:"#223843"}}
                            className="d-flex align-items-center fs-6 bio-item"
                          >
                            <FaHashtag className="me-2" />
                            <p className="m-0 small">
                              {' '}
                              <span className="fw-bold">Pincode : </span>{' '}
                              {instituteCookies?.pincode || ''}
                            </p>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </div>

            <div className="text-center mt-4 d-print-none">
              <Button variant="primary" onClick={handlePrint} className="me-2" style={{backgroundColor:"#223843",borderColor:"#223843"}}>
                Print ID Card
              </Button>
              <Button variant="success" onClick={handleDownloadBoth}>
                Download Image
              </Button>
            </div>
          </>
        ) : loading ? (
          <p>Loading ID Card...</p>
        ) : (
          <p>Unable to load user ID card. Open from Manage Users or add a valid user id in the URL.</p>
        )}
      </div>
    </>
  )
}
